import { cn } from 'src/utils/utils';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        'tw:animate-pulser tw:rounded-md tw:bg-secondary',
        className
      )}
      {...props}
    />
  );
}

export { Skeleton };
